import React from 'react';
import TicketLayout from '../components/ticket/TicketLayout';

/**
 * One ticket, as the contractor doing the work sees it: the same shell as
 * everybody else's (components/ticket/TicketLayout.js), in its contractor
 * variant - Log time first, their own Work & costs tab, Hand back and Ask to
 * reopen in the header. Under /my-tickets/:id, with the same tab sub-routes.
 * Private notes (086) are never sent to a contractor, so there is nothing
 * here to hide them: the server leaves them out.
 */
export default function ContractorTicket() {
  return <TicketLayout mode="contractor" />;
}
